import {Button, Modal, Spinner} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'
import {INodeAttachments} from '../../../../types/policiesApi'
import {useMutation} from '@apollo/client'
import {DELETE_FILE_POLICY} from '../../../../gql/mutations/policyMutation'
import {useEffect} from 'react'
import {toast} from 'react-toastify'
import {parseId} from '../../../../helpers'

interface IResDeleteFilePolicy {
  deleteAttachments: {success: boolean; errors?: {message: string}[]}
}

interface IModalProps {
  id: string
  isOpen: boolean
  onClose: () => void
  refetch: () => Promise<unknown> | void
  infoDoc: INodeAttachments
}
export const ModalDeleteDoc: React.FC<IModalProps> = ({id, infoDoc, isOpen, onClose, refetch}) => {
  const intl = useIntl()
  const [gqlDelete, {data, loading, error}] = useMutation<IResDeleteFilePolicy>(DELETE_FILE_POLICY)
  const errMsg = (message: string) =>
    intl.formatMessage({id: 'common.error.withMessage', defaultMessage: 'Error: {message}'}, {message})

  useEffect(() => {
    if (error) toast.error(errMsg(error.message))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.deleteAttachments.success) {
      onClose()
      refetch()
      toast.success(
        intl.formatMessage({
          id: 'policies.detail.tab.docs.toast.fileDeleted',
          defaultMessage: 'File deleted successfully',
        })
      )
    } else if (data.deleteAttachments.errors && data.deleteAttachments.errors.length > 0) {
      toast.error(errMsg(data.deleteAttachments.errors[0].message))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlDelete({
      variables: {
        id: parseId(infoDoc.id),
      },
    })
  }

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage
            id='policies.detail.tab.docs.delete.title'
            defaultMessage='Delete attachment'
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className='fs-2'>
          <FormattedMessage
            id='policies.detail.tab.docs.delete.confirm'
            defaultMessage='Are you sure you want to delete this attachment "{name}"?'
            values={{
              name: (
                <span className='text-danger text-uppercase fw-bold'>{infoDoc.name}</span>
              ),
            }}
          />
        </h4>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          <FormattedMessage id='common.action.cancel' defaultMessage='Cancel' />
        </Button>
        <Button variant='danger' onClick={handleDelete} disabled={loading}>
          {loading && <Spinner animation='border' size='sm' className='me-2' />} <FormattedMessage id='common.action.delete' defaultMessage='Delete' />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
